// QR改札チケット(サンリオなどのQRチケットとは別)
export const checkIsQrTicketGate = (pass) => {
  return pass.qrcode_ticket_kind != null;
}